<div style="padding:20px;">
  <span *ngIf="warning != ''" class="warningText">{{warning}}</span>
  <ng-container *ngIf="data.type=='self-exclude'">
    <p>
      You are attempting to self-exclude from paid contests and deposits for {{data.length}} days. Are you sure you want
      to continue? This will expire on {{ getDate() }}. <b>This action cannot be undone.</b>
    </p>
    <div style="width:100%;text-align:center;">
      <mat-form-field class="example-full-width">
        <mat-label>Enter your password</mat-label>
        <input matInput type="password" [(ngModel)]="up" (keyup)="submitExclusion($event)">
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" [disabled]="up == '' || loading" style="margin-right:10px;"
      class="addFundBtnD" (click)="submitExclusion()">CONFIRM</button>
  </ng-container>
  <ng-container *ngIf="data.type=='deposit'">
    <p>
      You are attempting to limit your deposits to a total of ${{data.amount}} for {{data.length}} days. Are you sure
      you want to continue? This will expire on {{ getDate() }}. <b>This action cannot be undone.</b>
    </p>
    <div style="width:100%;text-align:center;">
      <mat-form-field class="example-full-width">
        <mat-label>Enter your password</mat-label>
        <input matInput type="password" [(ngModel)]="up" (keyup)="submitDepositLimit($event)">
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" [disabled]="up == '' || loading" style="margin-right:10px;"
      class="addFundBtnD" (click)="submitDepositLimit()">CONFIRM</button>
  </ng-container>
  <button mat-raised-button color="warn" class="addFundBtnD" (click)="closeWithout()">CANCEL</button>
</div>